// extracted by mini-css-extract-plugin
export default {"action-sheet__not-found":"tRFaw"};